import { Vehicle } from '@typeRoots/common/vehicles';

// Validates the VIN decoder response to ensure it contains valid data
export const isVinDecoderResponseValid = (data: Partial<Vehicle>): boolean => {
  // Convert every value to a string and check if it's not empty after trimming spaces
  return Object.values(data).some((value) => String(value).trim().length > 0);
};

export const handleInputChange = (
  field: keyof Vehicle,
  value: string,
  onChange: (field: keyof Vehicle, value: string) => void,
) => {
  let cleaned = value.trimStart(); // remove leading spaces

  switch (field) {
    case 'year':
      // Validate for 4 digits only
      if (/^\d{0,4}$/.test(cleaned) && cleaned.length <= 4) {
        onChange(field, cleaned); // Only allow 4 digits (numeric)
      }
      break;

    case 'make':
    case 'model':
      // Prevent special characters and validate length
      cleaned = cleaned.replace(/\s{2,}/g, ' '); // prevent multiple spaces
      // Only allow letters, numbers, spaces, and common symbols
      if (/^[\p{L}\p{N}\s&\-'.(),]*$/u.test(cleaned) && cleaned.length <= 255) {
        onChange(field, cleaned);
      }
      break;

    default:
      onChange(field, cleaned);
  }
};
